import { TEMA_ROUTE_PATHS } from "../routes/temaRouteConstants";
import { navigateToRoute } from "../routes/navigateToRoute";

export const CERTIFICATION_WINDOW_NAME = "aife-certification";

export function buildCertificationHref() {
  return `${window.location.origin}${window.location.pathname}${window.location.search}${TEMA_ROUTE_PATHS.CERTIFICATION}`;
}

export function copySessionStorageTo(targetWindow) {
  if (!targetWindow?.sessionStorage) {
    return;
  }

  for (let index = 0; index < sessionStorage.length; index += 1) {
    const key = sessionStorage.key(index);
    if (!key) {
      continue;
    }
    targetWindow.sessionStorage.setItem(key, sessionStorage.getItem(key) ?? "");
  }
}

export function hydrateSessionFromOpener() {
  if (typeof window === "undefined") {
    return;
  }

  try {
    const opener = window.opener;
    if (!opener || opener.closed || !opener.sessionStorage) {
      return;
    }

    const source = opener.sessionStorage;
    for (let index = 0; index < source.length; index += 1) {
      const key = source.key(index);
      if (!key || sessionStorage.getItem(key)) {
        continue;
      }
      sessionStorage.setItem(key, source.getItem(key) ?? "");
    }
  } catch {
    // Opener is cross-origin or sessionStorage is blocked.
  }
}

function ensureCertificationHash(child, href) {
  try {
    if (child.location.hash !== TEMA_ROUTE_PATHS.CERTIFICATION) {
      child.location.replace(href);
    }
  } catch {
    // The child may still be navigating on first paint.
  }
}

/** Leaves AIFE: focuses the iTEMA tab that opened it, or routes this window to the dashboard. */
export function returnToTema() {
  let opener = null;
  try {
    opener = window.opener && !window.opener.closed ? window.opener : null;
    // Reading location throws when the opener is cross-origin.
    if (opener && opener.location.origin !== window.location.origin) {
      opener = null;
    }
  } catch {
    opener = null;
  }

  if (opener) {
    try {
      opener.focus();
      window.close();
      return;
    } catch {
      // Fall through to in-window navigation.
    }
  }

  navigateToRoute(TEMA_ROUTE_PATHS.DASHBOARD);
}

export function openCertificationWindow() {
  const href = buildCertificationHref();

  if (window.name === CERTIFICATION_WINDOW_NAME) {
    navigateToRoute(TEMA_ROUTE_PATHS.CERTIFICATION);
    return;
  }

  // Open the real URL immediately. `about:blank` + replace() races on first
  // click: the blank document can finish loading after replace() and leave a
  // white window until the named popup is reused on a second click.
  const child = window.open(href, CERTIFICATION_WINDOW_NAME);
  if (!child) {
    navigateToRoute(TEMA_ROUTE_PATHS.CERTIFICATION);
    return;
  }

  try {
    copySessionStorageTo(child);
  } catch {
    // Child boot hydrates missing keys from window.opener.
  }

  try {
    child.addEventListener?.(
      "load",
      () => ensureCertificationHash(child, href),
      { once: true },
    );
    if (child.document?.readyState === "complete") {
      ensureCertificationHash(child, href);
    }
    child.focus();
  } catch {
    // Popup already opened; avoid navigating the original tab away.
  }
}
